/* eslint-disable no-unused-vars */
function initMobileMenu() {
  // Mobi menu
  $('body .hamburger').on('click', function() {
    $('body').toggleClass('mobi-menu-open');
    $(this).toggleClass('is-active');
  });
}
